var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolkit-page"},_vm._l((_vm.list),function(item){return _c('Card',{key:item._id,attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }